const appointmentsOffer = [
  'Fertility assessments and preconception consultation',
  'Egg, sperm and embryo freezing',
  'Fertility treatments including IVF',
  'Family building options including donor egg, donor sperm, donor embryo, and surrogacy',
  'Wellness coaching to support your fertility journey'
];

export const componentTitle = 'Book your next appointment';
export const componentDescription =
  'We provide a complete suite of reproductive clinical care & coaching:';

export function getAppointmentsOfferString(): string {
  return appointmentsOffer.join('\n');
}
